import React, { useState } from 'react';
import Icon from '../common/Icon';
import { handleFieldsetEdit } from './constants/handleFieldset';
import { sortable } from '../../helpers/sorters';

const FieldsetListItem = ({
  fieldset,
  hasSubmissions,
  setFieldsets,
  handleDestroy,
  handleCopy,
  handleFieldMoveModal,
}) => {
  const { name, comment, title_hidden, id, fields, conditional_type } =
    fieldset;
  const [expanded, setExpanded] = useState(false);

  const handleExpand = (e) => {
    e.stopPropagation();
    setExpanded(!expanded);
  };

  async function handleUpdate(e, property, value) {
    e.preventDefault();
    let fieldset = {};
    fieldset[property] = value;
    let edited = await handleFieldsetEdit(fieldset, id);
    if (edited.ok) {
      setFieldsets((fieldsets) => {
        let updated = fieldsets.find((obj) => obj.id === id);
        updated[property] = value;
        let untouched = fieldsets.filter((obj) => obj.id != id);
        return sortable([...untouched, edited.data]);
      });
    }
  }

  return (
    <>
      <div className='cargo'>
        <div className='name'>{name}</div>
        <div className='meta'>
          {fields.length > 0 && (
            <>
              <Icon
                icon={expanded ? 'chevron-up' : 'chevron-down'}
                onClick={handleExpand}
              />{' '}
            </>
          )}
          {comment || 'No comment provided.'}
          {conditional_type && (
            <>
              {' | '}
              <Icon
                icon='clipboard-question'
                title='Conditional Fieldset Type'
                disabled
              />{' '}
              {conditional_type.charAt(0).toUpperCase() +
                conditional_type.slice(1)}
            </>
          )}
        </div>
        {expanded && (
          <div className='meta' style={{ cursor: 'default' }}>
            <ul className='fields-dropdown'>
              {fields.map((f) => (
                <li key={`field-${f.id}`}>
                  <b>{f.name}</b>
                  <div className='controls'>
                    {f.type}{' '}
                    <Icon
                      title='Move Field'
                      icon='arrows'
                      onClick={(e) => handleFieldMoveModal(e, f)}
                    />
                    <Icon
                      title={f.required ? 'Required' : 'Optional'}
                      icon='flag'
                      className={'flag' + (f.required ? ' required' : '')}
                    />
                    <Icon
                      url={`/manage/fields/${f.id}`}
                      className='edit'
                      title='Edit Field'
                      icon='pencil'
                      isLink
                    />
                  </div>
                </li>
              ))}
            </ul>
          </div>
        )}
      </div>

      <div className='controls'>
        <Icon
          className='duplicate'
          onClick={(e) => handleCopy(e, id)}
          icon='copy'
          faPrefix={'regular'}
        />
        <Icon
          className='toggle-switch title'
          title={`${title_hidden ? 'show' : 'hide'} fieldset title`}
          onClick={(e) => {
            handleUpdate(e, 'title_hidden', !title_hidden);
          }}
          icon={`${title_hidden ? 'eye-slash' : 'eye'}`}
          faPrefix={'regular'}
        />
        <Icon
          className={'toggle-switch public' + (fieldset.public ? ' on' : '')}
          title={`make ${fieldset.public ? 'private' : 'public'}`}
          onClick={(e) => {
            handleUpdate(e, 'public', !fieldset.public);
          }}
          icon={`${fieldset.public ? 'unlock-alt' : 'lock'}`}
        />
        <Icon
          url={`/manage/fieldsets/${id}`}
          className='edit'
          title='Edit Fieldset'
          icon='pencil'
          isLink
        />

        {!hasSubmissions && (
          <Icon
            className='destroy'
            onClick={(e) => handleDestroy(e, fieldset)}
            icon='trash'
          />
        )}
      </div>
    </>
  );
};

export default FieldsetListItem;
